import React from 'react';
import { Box } from 'rebass';
import { Column } from '../../../../hooks/useTablePages';
import { SurveyTemplateItem } from './SurveyTemplates.query';

const columns: Column[] = [
  {
    header: 'ID',
    accessor: 'id',
    width: 100,
  },
  {
    header: 'Name',
    accessor: 'name',
    width: 250,
  },
  {
    header: 'Description',
    accessor: 'description',
    width: 600,
  },
  {
    header: 'Hazards',
    id: 'hazards',
    sortable: false,
    accessor: (item: SurveyTemplateItem) => (
      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: 1 }}>
        {item.items.length}
      </Box>
    ),
    stringAccessor: (item: SurveyTemplateItem) => item.items.length.toString(),
    width: 100,
  },
];

export default columns;
